<!--
 * @Descripttion: 虚拟建造产品定价
 * @version: 
 * @Author: zouxin
 * @email: 1294644276@qq.com
 * @Date: 2024-12-17 16:08:25
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-20 16:09:13
-->
<template>
  <div class="mainBox">
    <div class="content">
      <div class="title">产品定价</div>
      <div class="pubTitle">选择您心仪的方案</div>
      <div class="priceList">
        <div class="priceItem" v-for="(item, index) in priceList" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="text">适合...</div>
          <div class="price">￥3,000 <span class="unit">/ 年</span></div>
          <div class="allRights">
            <div v-for="(right, i) in item.rights" :key="i">
              <!-- <span class="iconfont icon-duigou"></span> -->
              √ {{ right.name }}
            </div>
          </div>
          <div class="buyBtn" @click="openModal">立即购买</div>
        </div>
      </div>
      <div class="title">增值服务</div>
      <div class="pubTitle">适合您的服务</div>
      <div class="serviceList">
        <div class="serviceItem" v-for="(item, index) in serviceList" :key="index">
          <div class="contTitle">{{ item.title }}</div>
          <div class="contentLit" v-for="(content, i) in item.contents" :key="i">
            <div></div>
            {{ content.name }}
          </div>
        </div>
      </div>
      <div class="more">
        <div class="contTitle">更多</div>
        <div class="contentLit">
          <div></div>
          升级专属技术支持服务
        </div>
        <div class="contentLit">
          <div></div>
          线上/线下专业培训、现场技术支持
        </div>
        <div class="contentLit">
          <div></div>
          场景、沙盘、动画、静态、动态模型制作服务
        </div>
        <div class="askBtn" @click="openModal">立即咨询</div>
      </div>
    </div>
    <div class="callUs">
      <div class="callBox">
        <div class="boxLeft">
          <div class="boxTitle">有企业安全、采购或定制合同的问题？ <span>联系我们</span></div>
          <div class="telephone">
            <img src="~@/assets/img/telephone.png" alt="" /> <span>15872369729（李先生）</span>
            <!-- <div>13889166085（张先生）</div>
            <div>周一到周五 8:30-18:00</div> -->
          </div>
          <div class="email">
            <img src="~@/assets/img/email.png" alt="" /> <span>合作咨询 bicubemotion@163.com</span>
          </div>
        </div>
        <div class="boxRight">
          <div>联系我们</div>
          <div class="scanCode">
            <div class="rqcode" style="margin-right: 15px">
              <div></div>
            </div>
            <div class="rqcode">
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
    <page-right></page-right>
    <a-modal width="832px" :footer="false" :bodyStyle="{
      height: '396px',
    }" class="scan-modal" :closable="false" title="" v-model="captchaModal">
      <div class="modalBox">
        <div class="qr-close">
          <div class="icon-close" @click="closeModal"></div>
        </div>
        <div class="title">联系我们</div>
        <div class="information">
          <div class="callLeft">
            <div><img src="~@/assets/img/telephone.png" alt="" style="margin-right: 8px" /><span>联系电话</span></div>
            <div>15872369729（李先生）</div>
            <div>13889166085（张先生）</div>
            <div>周一到周五 8:30-18:00</div>
            <div style="margin-top: 30px">
              <img src="~@/assets/img/email.png" alt="" style="margin-right: 8px" /><span>{{ $t('base.contactEmail') }}</span>
            </div>
            <div>bicubemotion@163.com</div>
          </div>
          <div class="wechat">
            <div class="company">
              <img src="~@/assets/img/wechat.png" alt="" style="margin-right: 8px" /><span>{{ $t('base.enterpriseWechat') }}</span>
            </div>
            <div class="rqcode">
              <div></div>
            </div>
          </div>
        </div>
        <img class="customer" src="~@/assets/images/customer.png" alt="" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import './index.less'
import pageFooter from './components/footer.vue'
import pageRight from './components/rightInformation.vue'
export default {
  name: 'productPrice',
  components: {
    pageFooter,
    pageRight,
  },
  data() {
    return {
      priceList: [
        {
          title: '专业版',
          rights: [
            { name: '1个客户端许可证' },
            { name: '所有使用功能' },
            { name: '不限创建项目数量' },
            { name: '不限生成离线部署包数量' },
            { name: '不限发布云渲染数量' },
            { name: '支持同时3人在线预览' },
            { name: '赠送10G云渲染空间' },
            { name: '7x24小时技术支持' },
            { name: '免费持续更新软件' },
            { name: '赠送2次线上培训服务' },
          ],
        },
        {
          title: '离线版',
          rights: [
            { name: '1个客户端许可证' },
            { name: '所有使用功能' },
            { name: '不限创建项目数量' },
            { name: '不限生成离线部署包数量' },
            { name: '7x24小时技术支持' },
            { name: '1年内免费更新软件' },
            { name: '赠送2次线上培训服务' },
            { name: '赠送现场软件安装服务' },
          ],
        },
        {
          title: '私有化部署版',
          rights: [
            { name: '1个客户端许可证' },
            { name: '所有使用功能' },
            { name: '不限创建项目数量' },
            { name: '不限生成离线部署包数量' },
            { name: '7x24小时技术支持' },
            { name: '1年内免费更新软件' },
            { name: '赠送2次线上培训服务' },
            { name: '赠送私有化部署服务' },
          ],
        },
        {
          title: '永久版',
          rights: [
            { name: '1个客户端许可证' },
            { name: '永久使用时间' },
            { name: '所有使用功能' },
            { name: '不限创建项目数量' },
            { name: '不限生成离线部署包数量' },
            { name: '专属技术支持' },
            { name: '1年内免费更新软件' },
            { name: '赠送2次现场培训服务' },
          ],
        },
      ],
      serviceList: [
        {
          title: '订阅时间拓展',
          contents: [
            { name: '到期前一个月续费，享受9折优惠。' },
            { name: '一次性购买2年或以上，分别享受85折和8折优惠。' },
            { name: '一次性购买5个许可证或以上，分别享受85折和8折优惠。' },
          ],
        },
        {
          title: '云渲染空间扩容',
          contents: [
            { name: '同时支持在线预览人数：￥6000/人/年/1个客户端许可证' },
            { name: '云渲染空间扩容：100G/￥800/年/1个客户端许可证' },
          ],
        },
      ],
      captchaModal: false,
    }
  },
  methods: {
    // 展示联系我们弹窗
    openModal() {
      this.captchaModal = true
    },

    // 关闭弹窗
    closeModal() {
      this.captchaModal = false
    },
  },
}
</script>